<script>
import { mapGetters } from 'vuex'
export default
{
    name: 'signup-form',

    computed:
    {
        ...mapGetters({offers: 'offers', page: 'page', stackedOffers: 'stackedOffers', stackedUrl: 'stackedUrl', thanksUrl: 'thanksUrl'}),

        fields()
        {
            let fields = this.page && this.page.fields ? this.page.fields : []
            return fields.sort((a,b) => a.pivot.order - b.pivot.order) 
        },

        months()
        {
            const arr = []
            for (let i = 0; i < this.$moment.months().length; ++i)
            {
                arr.push({
                    id: i + 1,
                    name: this.$moment.months()[i]
                })
            }
            return arr
        },

        years()
        {
            const arr = []
            for (let i = 0; i < 3; ++i)
            {
                arr.push({
                    id: this.$moment().year()+ i,
                    name: this.$moment().year()+ i,
                })
            }
            return arr
        },

        roles()
        {
            return [
                'Bride', 'Bridesmaid', 'Groom', 'Wishful (soon-to-be) bride' // @TODO: API
            ]
        },

    },

    watch:
    {
        'model.wedding_month': 'adjustMonth',
        'model.wedding_year': 'adjustMonth',
    },

    methods:
    {
        async send()
        {
            await this.$store.dispatch('signup', this.model)

            this.$analytics.fbq.event('CompleteRegistration')
            if(this.page.client.channel.is_redirect_to_loverly)
            {
                const res = await this.$store.dispatch('registerUser', this.model)
                window.localStorage.setItem('loverly_redirect', this.page.client.channel.redirect_url + res.token)
            }
            if (this.stackedOffers.length != 0)
            {
                this.$router.replace(this.stackedUrl)
            } else {
                if (this.offers.length == 0)
                {
                    this.$router.replace(this.thanksUrl)
                } else {
                    this.$router.replace(this.offers[0].url)
                }
            }
        },

        adjustMonth()
        {
            if (this.model.wedding_year == (new Date).getFullYear())
            {
                if (this.model.wedding_month < (new Date).getMonth() + 1)
                {
                    this.model.wedding_month = (new Date).getMonth() + 1
                }
            }
        },
    },

    data()
    {
        return {
            model: {
                wedding_month: 0,
                wedding_year: 2018,
            },
        }
    },

    mounted()
    {
        this.adjustMonth()
    }

}
</script>

<template>
<div class="signup-form-container main">
    <form @submit.prevent="send" id="checklist-form">
        <div class="row half-gutters">
            <div :class="field.pivot.class || 'col-sm-12'" v-for="field in fields" :key="field.id">
                <div class="form-group">
                    <label :for="'input-' + field.id">{{ field.label }} </label>
                    <input
                        v-model="model[field.name]"
                        :name="field.name"
                        :type="field.type"
                        required="required"
                        class="form-control"
                        :id="'input-' + field.id"
                        v-if="field.type != 'select'">
                    <select
                        required="required" class="form-control"
                        v-if="field.type == 'select'"
                        v-model="model[field.name]"
                        >
                        <option v-for="val in field.values" :key="val" :value="val">{{ val }}</option>
                    </select>
                </div>
            </div>
        </div>

        <button type="submit" class="btn btn-submit text-uppercase mb-4">
            {{ page.label_signup }}
        </button>

        <div class="form-check">
            <input v-model="model.read_the_tos"  type="checkbox" id="signupReadTos" name="read_the_tos" required="required" checked="checked" class="form-check-input">
            <label for="signupReadTos" class="form-check-label">
                By checking this box,
                I agree to the <a href="http://loverly.test.webandmore.hu/terms">Terms</a>
                and have read the <a href="http://loverly.test.webandmore.hu/privacy">Data Use Policy</a>,
                including  Cookie Use.
            </label>
        </div>
    </form>
</div>
</template>



// WEBPACK FOOTER //
// src/components/elements/SignupForm.vue